import { Directive } from '@angular/core';

@Directive({
  selector: '[itemTemplate]',
  standalone: true,
})
export class DropdownsItemTemplateDirective {}
